import { connect } from 'react-redux'

import {
  getKeys,
  getKeysCount,
  getKeysListIsLoading,
  getErrorMessageConfig,
  getConfigSuccess,
  getKeyCreatedObject,
} from '../../../redux/configuration/selectors'
import {
  fetchKeys,
  getKeysMore,
  onSearchCleRessources,
  pageChangedKeys,
  resetConfig,
} from '../../../redux/configuration/actions'

import DriverModal from '../../../pages/settings/components/Modals/DriverModal'
import {
  getErrorMessageDriversSettings,
  getisLoadingDriverSettingsAction,
  getSuccessDriversSettings,
} from '../../../redux/driver/selectors'
import {
  createDriver,
  resetDriversConfig,
  updateDriver,
} from '../../../redux/driver/actions'
const mapStateToProps = (state) => ({
  isLoadingDriverAction: getisLoadingDriverSettingsAction(state),

  success: getSuccessDriversSettings(state),
  errorMessage: getErrorMessageDriversSettings(state),
  errorMessageConfig: getErrorMessageConfig(state),

  keys: getKeys(state),
  isLoadingKeysList: getKeysListIsLoading(state),
  keysCount: getKeysCount(state),

  successConfig: getConfigSuccess(state),
  keyCreatedObject: getKeyCreatedObject(state),
})

const mapDisptachToProps = (dispatch) => ({
  createDriver: (driver) => dispatch(createDriver(driver)),
  updateDriver: (newDriver, id) => dispatch(updateDriver(newDriver, id)),

  fetchKeys: () => {
    dispatch(onSearchCleRessources(''))
    dispatch(fetchKeys())
  },
  searchKeys: (search) => {
    dispatch(onSearchCleRessources(search))
    dispatch(pageChangedKeys(0))
    dispatch(fetchKeys())
  },
  fetchMoreKeys: (offset, search) => {
    dispatch(onSearchCleRessources(search))
    dispatch(pageChangedKeys(offset))
    dispatch(getKeysMore())
  },
  resetKey: () => dispatch(resetConfig()),
  resetDriversConfig: () => dispatch(resetDriversConfig()),
})

export default connect(mapStateToProps, mapDisptachToProps)(DriverModal)
